import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Card,
  Modal,
  DatePicker,
  TimePicker,
  Table,
  Select,
  Form,
  Space,
  Tag,
  Input,
  Tooltip,
  Popover,
} from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  EditOutlined,
  DeleteOutlined,
  HourglassFilled,
  HourglassTwoTone,
  ClockCircleTwoTone,
  FilterFilled,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { FormattedMessage, useIntl } from "react-intl";
import DispatchTool from "./DispatchTool";
import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteAppointmentsByApptId,
  getAppointmentDetailsByApptId,
  getAppointmentsByWOId,
} from "./AppointmentApi";
import {
  getEmployeesAPI,
  getStatusAPI,
  getTechniciansAPI,
} from "CommonComponents/Lookup/LookupAPI";
import dayjs from "dayjs";
import StatusEnum from "features/Enums/StatusEnum";
import { resetAppointmentByApptId } from "./AppointmentSlice";
import { use } from "react";
import utc from "dayjs/plugin/utc";
import { GetSubContractorsApi } from "features/Admin/SubContractor/SubContractorAPI";
dayjs.extend(utc);
function AppointmentList() {
  const { Column } = Table;
  const { TextArea } = Input;
  const { Option } = Select;
  const now = dayjs.utc();
  const intl = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id, clientId, partnerId, workOrderId } = useParams();
  const selectedLanguage = localStorage.getItem("selectedlanguage") || "fr-FR";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAppointmentStatusIds, setSelectedAppointmentStatusIds] =
    useState([]);
  const [selectedTechnicianIds, setSelectedTechnicianIds] = useState([]);
  const [selectedSubContractorIds, setSelectedSubContractorIds] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [editAppointment, setEditAppointment] = useState(null);
  const companyId = localStorage.getItem("CompanyId");
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const showModal = () => {
    setEditAppointment(null);
    setIsModalOpen(true);
    resetAppointmentByApptId();
  };
  const handleOk = () => setIsModalOpen(false);
  const handleCancel = () => {
    setIsModalOpen(false);
    setEditAppointment(null);
    resetAppointmentByApptId();
  };
  const appointmentsList = useSelector(
    (state) => state.appointments.appointmentsList
  );
  const subContractorsList = useSelector(
    (state) => state.subContractor.subContractorRecords
  );
  const appointmentByApptId = useSelector(
    (state) => state.appointments.appointmentByApptId
  );
  const totalPages = useSelector((state) => state.appointments.totalPages);
  const techniciansList = useSelector((state) => state.lookup.technicians);
  const statusList = useSelector((state) => state.lookup.statusList);
  const getTechnicianNameById = (technicianId) => {
    const technician = techniciansList?.find(
      (item) => item?.id == technicianId
    );
    return technician
      ? `${technician.firstName} ${technician.lastName}`
      : "N/A";
  };
  const filteredAppointmentsList = appointmentsList?.filter((item) => {
    const matchesStatus =
      selectedAppointmentStatusIds.length === 0 ||
      selectedAppointmentStatusIds.includes(item.appointmentStatusId);

    const matchesTechnician =
      selectedTechnicianIds.length === 0 ||
      item.appointmentTechnicians?.some((t) =>
        selectedTechnicianIds.includes(t.technicianId)
      );

    const matchesSubContractor =
      selectedSubContractorIds.length === 0 ||
      (item.subContractorId &&
        selectedSubContractorIds.includes(item.subContractorId));

    return matchesStatus && matchesTechnician && matchesSubContractor;
  });
  const handleEdit = (record) => {
    dispatch(getAppointmentDetailsByApptId(record.id));
    setEditAppointment(record);
    setIsModalOpen(true);
  };
  const pagination = {
    pageNumber: currentPage,
    pageSize: 10,
    searchQuery: "",
    companyFilter: null,
    statusFilter: null,
    salespersonFilter: null,
    startDate: null,
    endDate: null,
    quoteTypeIds: null,
    statusIds: null,
  };

  useEffect(() => {
    const input = {
      pageNo: currentPage,
      pageSize: 10,
      searchQuery: "",
      quoteTypeIds: null,
      statusIds: null,
    };
    dispatch(getAppointmentsByWOId(workOrderId, input));
  }, [workOrderId, currentPage]);
  useEffect(() => {
    dispatch(getEmployeesAPI());
    dispatch(getTechniciansAPI());
    dispatch(getStatusAPI());
    dispatch(
      GetSubContractorsApi({
        pageNumber: currentPage,
        pageSize: 10,
        searchQuery: "",
      })
    );
  }, []);

  return (
    <>
      <Row
        justify="space-between"
        align="middle"
        gutter={[16, 16]} // adds vertical space on mobile
        style={{ flexWrap: "wrap" }}
      >
        {/* 🧾 Title */}
        <Col xs={24} sm={12} md={4}>
          <h5 style={{ marginBottom: 0 }}>
            <FormattedMessage id="Appointment.Appointment" />
          </h5>
        </Col>

        {/* 🧩 Status List + Button */}
        <Col
          xs={24}
          sm={12}
          md={18}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            flexWrap: "wrap",
            gap: "12px",
          }}
        >
          <ul
            className="statslist-new"
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "12px",
              padding: 0,
              margin: 0,
            }}
          >
            <li
              style={{
                listStyle: "none",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CheckCircleTwoTone
                twoToneColor="#52c41a"
                style={{ fontSize: 14 }}
              />
              &nbsp;&nbsp;
              <FormattedMessage id="Appointment.Approved" />
            </li>
            <li
              style={{
                listStyle: "none",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CloseCircleTwoTone
                twoToneColor="#ff4d4f"
                style={{ fontSize: 14 }}
              />
              &nbsp;&nbsp;
              <FormattedMessage id="Appointment.Declined" />
            </li>
            <li
              style={{
                listStyle: "none",
                display: "flex",
                alignItems: "center",
              }}
            >
              <ClockCircleTwoTone
                twoToneColor="#faad14"
                style={{ fontSize: 14 }}
              />
              &nbsp;&nbsp;
              <FormattedMessage id="Appointment.Waiting" />
            </li>
          </ul>

          <Button size="small" type="primary" onClick={showModal}>
            <FormattedMessage id="Appointment.AddAppointment" />
          </Button>
        </Col>
      </Row>

      <Table
        dataSource={filteredAppointmentsList}
        rowKey="id"
        bordered
        scroll={{ x: 1100 }}
        pagination={{
          current: currentPage,
          total: totalPages * 10,
          showSizeChanger: false,
          onChange: handlePageChange,
        }}
        className="mt-10"
      >
        <Column
          title={<FormattedMessage id="Appointment.Sno" />}
          dataIndex="sno"
          key="sno"
          width={50}
          render={(text, record, index) =>
            (pagination.pageNumber - 1) * pagination.pageSize + index + 1
          }
        />
        <Column
          title={<FormattedMessage id="Appointment.AppointmentNumber" />}
          dataIndex="appointmentNumber"
          key="appointmentNumber"
          width={200}
          render={(text, record) => {
            let path = null;

            if (clientId && partnerId) {
              path = `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details/wo_details/${workOrderId}/appointmentdetails/${record.id}`;
            } else if (clientId) {
              path = `/${companyId}/${clientId}/client_details/wo_details/${workOrderId}/appointmentdetails/${record.id}`;
            } else if (partnerId) {
              path = `/${companyId}/${partnerId}/partner_client_details/wo_details/${workOrderId}/appointmentdetails/${record.id}`;
            }

            return path ? (
              <Link to={path}>{record.appointmentNumber}</Link>
            ) : (
              <span>{record.appointmentNumber}</span>
            );
          }}
        />
        <Column
          title={<FormattedMessage id="AddAppointment.StartDate" />}
          width={150}
          dataIndex="startDate"
          key="startDate"
        />
        <Column
          title={<FormattedMessage id="AddAppointment.StartTime" />}
          width={100}
          dataIndex="startTime"
          key="startTime"
          render={(time) =>
            time ? dayjs(time, "HH:mm:ss").format("HH:mm") : "--"
          }
        />
        <Column
          title={
            <FormattedMessage id="AddAppointment.Technicians/SubContractors" />
          }
          dataIndex="appointmentTechnicians"
          key="technicians"
          width={200}
          filterDropdown={() => (
            <div style={{ padding: 8, maxHeight: 300, overflowY: "auto" }}>
              {/* technician + subcontractor filter checkboxes here */}
              <Button
                onClick={() => {
                  setSelectedTechnicianIds([]);
                  setSelectedSubContractorIds([]);
                }}
                size="small"
                style={{ marginTop: 8, width: "100%" }}
              >
                {intl.formatMessage({ id: "Common.Reset" })}
              </Button>
            </div>
          )}
          filterIcon={() => (
            <FilterFilled
              style={{
                color: selectedTechnicianIds.length > 0 ? "#1890ff" : "white",
                fontSize: 15,
              }}
            />
          )}
          render={(text, record) => {
            // 🔹 Case 1: Subcontractors
            if (record.appointmentSubContractors?.length > 0) {
              const sub = record.appointmentSubContractors[0];
              return (
                <span>
                  <Tag color="purple" style={{ marginLeft: 4 }}>
                    SC
                  </Tag>
                  {sub.subContractorName}
                  {sub.subContractorStatusId === 1 && (
                    <ClockCircleTwoTone
                      twoToneColor="#faad14"
                      style={{ marginLeft: 6 }}
                    />
                  )}
                  {sub.subContractorStatusId === 2 && (
                    <CheckCircleTwoTone
                      twoToneColor="#52c41a"
                      style={{ marginLeft: 6 }}
                    />
                  )}
                  {sub.subContractorStatusId === 3 && (
                    <CloseCircleTwoTone
                      twoToneColor="#ff4d4f"
                      style={{ marginLeft: 6 }}
                    />
                  )}
                </span>
              );
            }

            // 🔹 Case 2: Technicians
            const technicians = record.appointmentTechnicians || [];
            if (technicians.length > 0) {
              const primaryTech = technicians[0];
              const extraCount = technicians.length - 1;

              let icon = null;
              if (primaryTech.technicianStatusId === StatusEnum.Waiting.id) {
                icon = (
                  <ClockCircleTwoTone
                    twoToneColor="#faad14"
                    style={{ marginLeft: 6 }}
                  />
                );
              } else if (
                primaryTech.technicianStatusId === StatusEnum.Approved.id
              ) {
                icon = (
                  <CheckCircleTwoTone
                    twoToneColor="#52c41a"
                    style={{ marginLeft: 6 }}
                  />
                );
              } else if (
                primaryTech.technicianStatusId === StatusEnum.Declined.id
              ) {
                icon = (
                  <CloseCircleTwoTone
                    twoToneColor="#ff4d4f"
                    style={{ marginLeft: 6 }}
                  />
                );
              }

              return (
                <span>
                  <Tag color="blue" style={{ marginRight: 4 }}>
                    T
                  </Tag>
                  {primaryTech.technicianName} {icon}
                  {extraCount > 0 && (
                    <Tooltip
                      title={
                        <div>
                          {technicians.map((t) => (
                            <div key={t.technicianId}>{t.technicianName}</div>
                          ))}
                        </div>
                      }
                    >
                      <span
                        style={{
                          color: "#101011dd",
                          cursor: "pointer",
                          marginLeft: 2,
                        }}
                      >
                        +{extraCount}
                      </span>
                    </Tooltip>
                  )}
                </span>
              );
            }
            return "N/A";
          }}
        />

        <Column
          title={<FormattedMessage id="Appointment.TotalTravelTime" />}
          dataIndex="totalTravelTime"
          key="totalTravelTime"
          width={200}
          render={(time) =>
            time ? dayjs(time, "HH:mm:ss").format("HH:mm") : "--"
          }
        />
        <Column
          title={<FormattedMessage id="Appointment.TotalTimeOnJob" />}
          dataIndex="totalJobTime"
          key="totalJobTime"
          width={200}
          render={(time) =>
            time ? dayjs(time, "HH:mm:ss").format("HH:mm") : "--"
          }
        />
        <Column
          title={<FormattedMessage id="ClientDetails.Status" />}
          dataIndex="appointmentStatusId"
          key="appointmentStatusId"
          width={150}
          filterDropdown={() => (
            <div style={{ padding: 8 }}>
              {statusList
                ?.filter((status) => [22, 23, 24].includes(status.id))
                .map((status) => (
                  <div key={status.id} style={{ marginBottom: 4 }}>
                    <label style={{ cursor: "pointer" }}>
                      <input
                        type="checkbox"
                        checked={selectedAppointmentStatusIds.includes(
                          status.id
                        )}
                        onChange={(e) => {
                          let updated = [];
                          if (e.target.checked) {
                            updated = [
                              ...selectedAppointmentStatusIds,
                              status.id,
                            ];
                          } else {
                            updated = selectedAppointmentStatusIds.filter(
                              (sid) => sid !== status.id
                            );
                          }
                          setSelectedAppointmentStatusIds(updated);
                        }}
                        style={{ marginRight: 8 }}
                      />
                      {selectedLanguage === "fr-FR"
                        ? status.nameFr
                        : status.nameEn}
                    </label>
                  </div>
                ))}
              <Button
                onClick={() => setSelectedAppointmentStatusIds([])}
                size="small"
                style={{ marginTop: 8, width: "100%" }}
              >
                {intl.formatMessage({ id: "Common.Reset" })}
              </Button>
            </div>
          )}
          filterIcon={() => (
            <FilterFilled
              style={{
                color:
                  selectedAppointmentStatusIds.length > 0 ? "#1890ff" : "white",
                fontSize: 15,
              }}
            />
          )}
          render={(statusId) => {
            const status = statusList?.find((s) => s.id === statusId);
            const label =
              selectedLanguage === "fr-FR" ? status?.nameFr : status?.nameEn;
            let color = "default";

            if (statusId === StatusEnum.NotStarted.id) color = "blue";
            else if (
              statusId === StatusEnum.InProgress.id ||
              statusId === StatusEnum.OnMyWay.id ||
              statusId === StatusEnum.Started.id
            )
              color = "gold";
            else if (statusId === StatusEnum.Paused.id) color = "red";
            else if (statusId === StatusEnum.Completed.id) color = "green";

            return <Tag color={color}>{label || "Unknown"}</Tag>;
          }}
        />

        <Column
          title="Actions"
          key="action"
          width={100}
          render={(_, record) => (
            <Space size="middle">
              {record.appointmentStatusId === 22 ? (
                <>
                  <Button size="small" onClick={() => handleEdit(record)}>
                    <EditOutlined />
                  </Button>

                  <Button
                    size="small"
                    danger
                    onClick={() => {
                      Modal.confirm({
                        title: intl.formatMessage({
                          id: "Appointment.DeleteConfirmation",
                        }),
                        content: intl.formatMessage({
                          id: "Appointment.DeleteContext",
                        }),
                        okText: intl.formatMessage({ id: "Common.Yes" }),
                        okType: "danger",
                        cancelText: intl.formatMessage({ id: "Common.No" }),
                        onOk: () =>
                          dispatch(
                            deleteAppointmentsByApptId(
                              record.id,
                              record.workOrderId,
                              {
                                ...pagination,
                                pageNumber: currentPage,
                              }
                            )
                          ),
                      });
                    }}
                  >
                    <DeleteOutlined />
                  </Button>
                </>
              ) : (
                <>
                  <Tooltip
                    title={<FormattedMessage id="Appointment.DeleteTooltip" />}
                  >
                    <Button size="small" disabled>
                      <EditOutlined />
                    </Button>
                  </Tooltip>

                  <Tooltip
                    title={<FormattedMessage id="Appointment.DeleteTooltip" />}
                  >
                    <Button size="small" danger disabled>
                      <DeleteOutlined />
                    </Button>
                  </Tooltip>
                </>
              )}
            </Space>
          )}
        />
      </Table>
      <Modal
        className="responsive-modal"
        title={
          editAppointment ? (
            <FormattedMessage id="Appointment.EditAppointment" />
          ) : (
            <FormattedMessage id="Appointment.AddAppointment" />
          )
        }
        open={isModalOpen}
        onOk={handleOk}
        width={900}
        footer={null}
        onCancel={handleCancel}
        centered
        okText="Save"
        styles={{
          body: {
            height: "500px",
          },
        }}
      >
        <DispatchTool
          onClose={handleCancel}
          initialValues={editAppointment ? appointmentByApptId : null}
          workOrderId={workOrderId}
          isEditMode={!!editAppointment}
        />
      </Modal>
    </>
  );
}
export default AppointmentList;
